import * as React from "react";
import { observer } from "mobx-react";
import { hashHistory } from "react-router";
import SeekerStore from "../../../stores/seekerStore";
import { Prereq, PrereqField } from "../../../models/opportunity";
import { OperatorType, PrereqType, ExperienceType } from "../../../models/enums";
import { Row, Col } from "react-flexbox-grid";
import Checkbox from "material-ui/Checkbox";
import { FormControlLabel } from "material-ui/Form";
import Button from "material-ui/Button";

@observer
export class AcceptPrereq extends React.Component<{ store: SeekerStore,prereq:Prereq, clear?:()=>void }, {}> {
  constructor(props: any) {
    super(props);
  }
  selectSelfCert = (chk:boolean, certId: string): void => {
    if (chk) {
      this.props.store.profileStore.addSelfCert(certId);
    } else {
      this.props.store.profileStore.deleteSelfCert(certId);
    }
    if (this.props.clear) {
      this.props.clear();
    }
  }
  render(): JSX.Element {
    const checked: any = { color: "#5B6770" };

    const fld: PrereqField = this.props.prereq.fields.find((pf: PrereqField): boolean => { return pf.type === PrereqType.Acceptance });
    if (!fld) {
      return null;
    }
    return <Row>
      <Col xs={12}>
        <FormControlLabel label={this.props.store.localization.fields.acceptPrereq} control={<Checkbox style={checked}
          checked={this.props.store.opportunityStore.prereqFulfilled(this.props.prereq)}
          onChange={(e: any, chk: boolean) => this.selectSelfCert(chk, fld.refVal)}  />} />
        </Col>
      </Row>;
  }
}

@observer
class EducationPrereq extends React.Component<{ store: SeekerStore, prereq: Prereq }, {}> {
  constructor(props: any) {
    super(props);
  }
  render(): JSX.Element {
    return <Row>
      <Col xs={12}>
        <Button raised color="secondary" onClick={() => hashHistory.push(`profile/add-experience/${ExperienceType.GEDDegree}`)} >{this.props.store.localization.fields.addEducation.addNew}</Button>
      </Col>
      </Row>;
  }
}

@observer
class CCLCPrereq extends React.Component<{ store: SeekerStore, prereq: Prereq }, {}> {
  constructor(props: any) {
    super(props);
  }
  render(): JSX.Element {
    return (<Row>
      <Col xs={12}>
        <Button raised color="secondary" onClick={() => hashHistory.push(`profile/add-experience/${ExperienceType.CCLC}?name=${this.props.prereq.title}`)} >{`${this.props.store.localization.fields.add} ${this.props.prereq.title}`}</Button> 
      </Col>
      </Row>);
  }
}

@observer
class AgePrereq extends React.Component<{ store: SeekerStore, prereq: Prereq }, {}> {
  constructor(props: any) {
    super(props);
  }
  render(): JSX.Element {
    return null;
  }
}

@observer
class AndPrereq extends React.Component<{ store: SeekerStore, prereq: Prereq }, {}> {
  constructor(props: any) {
    super(props);
  }
  render(): JSX.Element {
    return (<Row>
      <Col xs={12}>
        {this.props.store.localization.fields.and}
      </Col>
     </Row>);
  }
}

@observer
class OrPrereq extends React.Component<{ store: SeekerStore, prereq: Prereq }, {}> {
  constructor(props: any) {
    super(props);
  }
  render(): JSX.Element {
    return (<Row>
      <Col xs={12}>
        {this.props.store.localization.fields.or}
      </Col>
    </Row>);  }
}

@observer
export class PrereqEditor extends React.Component<{ store: SeekerStore, prereq: Prereq, clear?:()=>void }, {}> {
  constructor(props: any) {
    super(props);
  }
  render(): JSX.Element {
    const ctrls: JSX.Element[] = [];
    this.props.prereq.fields.map((pf: PrereqField, i: number): void => {
      if (pf.opType === OperatorType.FIELD) {
        switch (pf.type) {
          case PrereqType.Acceptance:
            ctrls.push(<AcceptPrereq key={i} store={this.props.store} prereq={this.props.prereq} clear={this.props.clear} />);
            break;
          case PrereqType.Age:
            ctrls.push(<AgePrereq key={i} store={this.props.store} prereq={this.props.prereq} />);
            break;
          case PrereqType.CCLC:
            ctrls.push(<CCLCPrereq key={i} store={this.props.store} prereq={this.props.prereq} />);
            break;
          case PrereqType.Education:
            ctrls.push(<EducationPrereq key={i} store={this.props.store} prereq={this.props.prereq} />);
        }
      } else if (pf.opType === OperatorType.AND) {
        ctrls.push(<AndPrereq key={i} store={this.props.store} prereq={this.props.prereq} />);
      } else if (pf.opType === OperatorType.OR) {
        ctrls.push(<OrPrereq key={i} store={this.props.store} prereq={this.props.prereq} />);
      }
    });
    return (
      <div>
        <Row>
          <Col xs={12}>
            <div dangerouslySetInnerHTML={{__html:this.props.prereq.description}}></div>
          </Col>
          <Col xs={12}>
            {this.props.store.opportunityStore.prereqFulfilledLabel(this.props.prereq)}
          </Col>
        </Row>
        <div>{ctrls}</div>
      </div>);
  }
}


// WEBPACK FOOTER //
// ./src/components/profile/prereqEditors/index.tsx